import { connect } from 'react-redux';

import { getFormValues } from 'redux-form';

import VerifyComponent from './VerifyComponent';

import { onUserVerified, verify } from './actionCreators';

const form = 'verify';

const mapStateToProps = (state, ownProps) => {
  const userData = ownProps?.location?.state || {};
  const initialValues = { ...userData, termsAndConditions: false };
  const formValues = getFormValues(form)(state);
  const hasAcceptedTerms = Boolean(formValues?.termsAndConditions);
  return {
    form,
    hasAcceptedTerms,
    initialValues,
    userData,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data) => verify(dispatch, data),
  onUserVerified: (data) => onUserVerified(dispatch, data),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyComponent);
